import HoustonLayout from '@eduzz/houston-ui/Layout';
import { makeStyles } from '@material-ui/core/styles';
import type { ReactNode } from 'react';
import React from 'react';
import { useObservable } from 'react-use-observable';
import { FIDCAlert } from 'v2/components/Pages/Dashboard/FIDCAlert';
import Footer from 'v2/components/Shared/Footer';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import AppAlert from './appAlert';
import { NavBar } from './NavBar';
import Toolbar from './Toolbar';

export const FOOTER_HEIGHT = 53;
export const TOOLBAR_HEIGHT = 64;

const styles = makeStyles((theme) => ({
  mainContent: {
    backgroundColor: '#fcfcfc',
    width: '100%',
    position: 'relative',
    minHeight: `calc(100vh - ${FOOTER_HEIGHT + TOOLBAR_HEIGHT}px)`,
    display: 'flex',
    flexDirection: 'column',
  },
  oldMainContent: {
    width: '100%',
    padding: '1.5rem 2rem 1rem 2rem',
    position: 'relative',
    maxWidth: 1440,
    minHeight: '100%',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: '1rem',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
}));

interface IProps {
  children: ReactNode;
}

const Layout = ({ children }: IProps) => {
  const classes = styles();

  const [modules] = useObservable(() => eduzzAccountsService.getBetaModules(), []);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  if (!modules || !user) return null;
  return (
    <>
      <HoustonLayout>
        <Toolbar />
        <NavBar />
        <HoustonLayout.Content>
          <main id='main-content' className={classes.mainContent}>
            <FIDCAlert />
            {children}
            <Footer />
          </main>
        </HoustonLayout.Content>
      </HoustonLayout>
      <AppAlert />
    </>
  );
};

export default Layout;
